import fileSaver from 'file-saver';
import { apiDownloadDocument } from '../api/imageReaderApi';

export function openDocumentInNewTab(pageList, documentTitle) {
  if (pageList.length > 0) {
    let windowObject = window.open('about:blank');
    pageList.forEach((page, index) => {
      appendImageToWindow(page.pageContent, windowObject, documentTitle, index);
    });
  }
}

export function downloadDocument(pageList, documentTitle) {
  return apiDownloadDocument(pageList, documentTitle)
    .then((response) => {
      const blob = new Blob([response], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, documentTitle);
    })
    .catch((error) => {
      console.warn('Unable to download the file: ', error);
    });
}

function appendImageToWindow(pageContent, windowObject, documentTitle, pageNumber) {
  // document object
  let document = windowObject.document;
  document.title = documentTitle;
  document.body.style.backgroundColor = '#333';
  document.body.style.textAlign = 'center';

  // creating main div
  let div = document.createElement('div');
  div.style.marginBottom = '20px';

  // creating image object
  let object = document.createElement('img');
  object.type = 'image/png';
  object.src = pageContent;
  object.style.textAlign = 'center';
  object.style.width = '500px';
  object.style.height = 'auto';
  object.style.marginBottom = '2px';

  // creating pagecount span object
  var span = document.createElement('span');
  span.style.color = 'white';
  span.style.textAlign = 'center';
  span.style.fontWeight = '700';
  var text = document.createTextNode(pageNumber + 1);
  span.appendChild(text);

  // creating br tag
  var br = document.createElement('BR');

  // appending all child objects in main div
  div.appendChild(object);
  div.append(br);
  div.appendChild(span);

  // adding main div to document's body
  document.body.appendChild(div);
}
